export const initPageTop = () => {
  const button = document.getElementById('js-page-top')
  if (button === null) return

  button.addEventListener('click', () => {
    window.scroll({ behavior: 'smooth', left: 0, top: 0 })
  })

  // 【仕組み】rootMarginで上に1/4画面分・下にbody全長分広げたビューポートでbodyを監視(threshold:1)。
  // 1/4画面分を超えてスクロールするとbodyが収まりきらなくなる(isIntersecting=false)のを利用してボタンを表示する
  const observer = new IntersectionObserver(
    (entries) => {
      if (typeof entries[0] === 'undefined') return
      const isShown = !entries[0].isIntersecting
      button.classList.toggle('invisible', !isShown)
      button.classList.toggle('opacity-0', !isShown)
    },
    {
      rootMargin: `${window.screen.availHeight / 4}px 0px ${document.body.clientHeight}px`,
      threshold: 1
    }
  )
  observer.observe(document.body)
}
